import React, { useEffect, useState } from 'react';
import NavbarWrapper from './Layout';
import axios from 'axios';
import { Button, Row, Col, Accordion, Card } from 'react-bootstrap';
import auth from '../config/FirebaseConfig';
import { useLocation } from 'react-router-dom';
import AccordionHeader from 'react-bootstrap/esm/AccordionHeader';
import AccordionBody from 'react-bootstrap/esm/AccordionBody';
import Decimal from 'decimal.js';
import AccordionItem from 'react-bootstrap/esm/AccordionItem';
import {
  DetailsStdComponent,
  handleInputChange,
} from '../utils/helpers/ComponentBuilder';
import { arrEl } from '../utils/helpers/commons';
const baseUrl = process.env.REACT_APP_API_BASE_URL;

interface Invoice {
  helpersCount: Decimal;
  workedHours: Decimal;
  vehicleCosts: Decimal;
  driverCost: Decimal;
}
const calculatedWorkedHours = (pricingDto: any): Decimal => {
  return new Decimal(pricingDto.movingHoursWorked)
    .plus(new Decimal(pricingDto.packingHoursWorked))
    .plus(new Decimal(pricingDto.assemblyHoursWorked));
};
const calculateVehicleCosts = (pricingDto: any): Decimal => {
  const distanceCost = new Decimal(pricingDto.vehicleKmCount).times(
    new Decimal(pricingDto.vehicleKmRate),
  );
  const waitingCost = new Decimal(pricingDto.vehicleWaitedMinutes).times(
    new Decimal(pricingDto.waitingMinRate),
  );
  return new Decimal(pricingDto.vehicleOpenRate)
    .plus(distanceCost)
    .plus(waitingCost);
};
const resolveInvoiceDetails = (details: any): Invoice => {
  return {
    helpersCount: new Decimal(details.helpersCount),
    workedHours: calculatedWorkedHours(details),
    vehicleCosts: calculateVehicleCosts(details),
    driverCost: new Decimal(details.driverCost),
  };
};
const MovingServiceDetails: React.FC = () => {
  const location = useLocation();
  if (!location.state?.order?.movingServiceDetails) {
    throw new Error('This case should never happen!');
  }
  const [order, setOrder] = useState<any>(location.state.order);
  const [token, setToken] = useState<string>('');
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const userToken = await auth.currentUser?.getIdToken();
        const res = await axios.get(
          `${baseUrl}/admin/v1/orders/${location.state.order.id}`,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          },
        );
        setOrder(res.data);
        setToken(userToken || '');
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };
    fetchOrder();
  }, [location.state.order.id]);
  console.log(order);
  const [invoiceDetails, setInvoiceDetails] = useState<Invoice>(
    resolveInvoiceDetails(order.movingServiceDetails),
  );
  const [movingServiceDetails, setMovingServiceDetails] = useState<any>(
    order.movingServiceDetails,
  );

  const issueInvoice = async () => {
    try {
      const userToken = await auth.currentUser?.getIdToken();
      const res = await axios.post(
        `${baseUrl}/admin/v1/orders/moving-service/issue-invoice`,
        {
          ...movingServiceDetails,
          vehicleOpenRate: invoiceDetails.vehicleCosts,
          vehicleKmCount: 0,
          vehicleWaitedMinutes: 0,
          movingHoursWorked: invoiceDetails.workedHours,
          packingHoursWorked: 0,
          assemblyHoursWorked: 0,
          helpersCount: invoiceDetails.helpersCount,
          driverCost: invoiceDetails.driverCost,
        },
        { headers: { Authorization: `Bearer ${userToken}` } },
      );
      setOrder(res.data);
      setMovingServiceDetails(res.data.movingServiceDetails);
      setInvoiceDetails(resolveInvoiceDetails(res.data.movingServiceDetails));
    } catch (error) {
      console.error('Error Issuing Invoice:', error);
    }
  };
  const confirmPayment = async () => {
    try {
      const userToken = await auth.currentUser?.getIdToken();
      await axios.post(
        `${baseUrl}/admin/v1/orders/moving-service/confirm-payment/${movingServiceDetails.id}`,
        {},
        { headers: { Authorization: `Bearer ${userToken}` } },
      );
      handleInputChange(
        movingServiceDetails,
        'confirmedPayment',
        true,
        setMovingServiceDetails,
      );
    } catch (error) {
      console.error('Error Issuing Invoice:', error);
    }
  };
  return (
    <NavbarWrapper>
      <Accordion>
        <AccordionItem eventKey="0">
          <AccordionHeader>Order Information</AccordionHeader>
          <AccordionBody>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'seq',
                  () => {},
                  'Order Number',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'description',
                  () => {},
                  'Order Description',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'createdAt',
                  () => {},
                  'Created At',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'contactInfo',
                  () => {},
                  'Contact Info',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(order, 'status', () => {}, 'Status', true)}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'paymentMethod',
                  () => {},
                  'Payment Method',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(order, 'price', () => {}, 'Price', true)}
              </Col>
              <Col>
                {DetailsStdComponent(order, 'currency', () => {}, null, true)}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'paymentStatus',
                  () => {},
                  'Payment Status',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'updatedAt',
                  () => {},
                  'Updated At',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'assignee',
                  () => {},
                  'Assignee',
                  true,
                )}
              </Col>
            </Row>
          </AccordionBody>
        </AccordionItem>
        <AccordionItem eventKey="1">
          <AccordionHeader>Location Details</AccordionHeader>
          <AccordionBody>
            <Card body> Pickup Details </Card>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'preferredPickupTimes',
                  () => {},
                  null,
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'size',
                  () => {},
                  'Moving Size',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'helpersCount',
                  () => {},
                  'Helpers Count',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'helpOnPickUp',
                  () => {},
                  'Help On Pickup',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'helpOnDropOff',
                  () => {},
                  'Help On DropOff',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'assembly',
                  () => {},
                  'Assembly',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'packing',
                  () => {},
                  'Packing',
                  true,
                )}
              </Col>
            </Row>
            <Card body className="mt-4">
              Pickup Location Details
            </Card>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'pickUpAddress',
                  () => {},
                  'Address',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}),
                  'residentDetails',
                  () => {},
                  'Name',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}),
                  'addressPhone',
                  () => {},
                  'Mobile',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}),
                  'addressDescription',
                  () => {},
                  'Description',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}).moveServiceLocationDetails ||
                    {},
                  'floor',
                  () => {},
                  'Floor',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}).moveServiceLocationDetails ||
                    {},
                  'apartment',
                  () => {},
                  'Apartment No.',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}).moveServiceLocationDetails ||
                    {},
                  'doorCode',
                  () => {},
                  'Door Code',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}).moveServiceLocationDetails ||
                    {},
                  'hasElevator',
                  () => {},
                  'Has Elevator',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}).moveServiceLocationDetails ||
                    {},
                  'elevatorFits',
                  () => {},
                  'ElevatorFits The content',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 0, {}).moveServiceLocationDetails ||
                    {},
                  'description',
                  () => {},
                  'Other Info',
                  true,
                )}
              </Col>
            </Row>
            <Card body className="mt-4">
              DropOff Location Details
            </Card>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'dropOffAddress',
                  () => {},
                  'Address',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}),
                  'residentDetails',
                  () => {},
                  'Name',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}),
                  'addressPhone',
                  () => {},
                  'Mobile',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}),
                  'addressDescription',
                  () => {},
                  'Description',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}).moveServiceLocationDetails ||
                    {},
                  'floor',
                  () => {},
                  'Floor',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}).moveServiceLocationDetails ||
                    {},
                  'apartment',
                  () => {},
                  'Apartment No.',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}).moveServiceLocationDetails ||
                    {},
                  'doorCode',
                  () => {},
                  'Door Code',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}).moveServiceLocationDetails ||
                    {},
                  'hasElevator',
                  () => {},
                  'Has Elevator',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}).moveServiceLocationDetails ||
                    {},
                  'elevatorFits',
                  () => {},
                  'ElevatorFits The content',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  arrEl(order.tripDetails, 1, {}).moveServiceLocationDetails ||
                    {},
                  'description',
                  () => {},
                  'Other Info',
                  true,
                )}
              </Col>
            </Row>
          </AccordionBody>
        </AccordionItem>
        <AccordionItem eventKey="2">
          <AccordionHeader>Extra Details</AccordionHeader>
          <AccordionBody>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'promoCode',
                  () => {},
                  'Promo Code',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'trackingId',
                  () => {},
                  'Tracking Id',
                  true,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'courierPhoneNumber',
                  () => {},
                  'Courier PhoneNumber',
                  true,
                )}
              </Col>
            </Row>
          </AccordionBody>
        </AccordionItem>
        <AccordionItem eventKey="3">
          <AccordionHeader>Issue Invoice</AccordionHeader>
          <AccordionBody>
            <Row>
              <Col>
                {DetailsStdComponent(
                  invoiceDetails,
                  'helpersCount',
                  setInvoiceDetails,
                  'Helpers Count',
                  false,
                )}
              </Col>
              <Col>
                {DetailsStdComponent(
                  invoiceDetails,
                  'workedHours',
                  setInvoiceDetails,
                  'Worked Hours',
                  false,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  invoiceDetails,
                  'vehicleCosts',
                  setInvoiceDetails,
                  'Vehicle Costs',
                  false,
                )}
              </Col>
              <Col>
                {DetailsStdComponent(
                  invoiceDetails,
                  'driverCost',
                  setInvoiceDetails,
                  'Driver Cost',
                  false,
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  className="m-lg-3"
                  variant="primary"
                  disabled={
                    order.status !== 'DROP_OFF_REACHED' ||
                    movingServiceDetails.invoiceReady
                  }
                  onClick={() => issueInvoice()}
                >
                  Issue Invoice
                </Button>
              </Col>
              <Col>
                <Button
                  className="m-lg-3"
                  variant="success"
                  disabled={
                    !movingServiceDetails.invoiceReady ||
                    movingServiceDetails.confirmedPayment ||
                    order.paymentMethod === 'PAY_ONLINE'
                  }
                  onClick={() => confirmPayment()}
                >
                  Confirm And Close
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  movingServiceDetails,
                  'estimatedPrice',
                  () => {},
                  'Initial Price',
                  true,
                )}
              </Col>
              <Col>
                {DetailsStdComponent(order, 'currency', () => {}, null, true)}
              </Col>
            </Row>
            <Row>
              <Col>
                {DetailsStdComponent(
                  order,
                  'price',
                  () => {},
                  'Invoice Price',
                  true,
                )}
              </Col>
              <Col>
                {DetailsStdComponent(order, 'currency', () => {}, null, true)}
              </Col>
            </Row>
          </AccordionBody>
        </AccordionItem>
        <AccordionItem eventKey="4">
          <AccordionHeader>Images</AccordionHeader>
          <AccordionBody>
            {DetailsStdComponent(order, 'files', () => {}, null, false, token)}
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </NavbarWrapper>
  );
};

export default MovingServiceDetails;
